import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast from "react-hot-toast";
import TaskSkeleton from "./TaskSkeleton";
import moment from "moment";

function downloadCSV(rows, filename) {
  const csv = rows.map(r => r.map(v => `"${String(v ?? "").replace(/"/g, '""')}"`).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

const MONTHS = [
    { value: 1, label: "Jan" }, { value: 2, label: "Feb" }, { value: 3, label: "Mar" },
    { value: 4, label: "Apr" }, { value: 5, label: "May" }, { value: 6, label: "Jun" },
    { value: 7, label: "Jul" }, { value: 8, label: "Aug" }, { value: 9, label: "Sep" },
    { value: 10, label: "Oct" }, { value: 11, label: "Nov" }, { value: 12, label: "Dec" },
];

function getYears() {
    const current = new Date().getFullYear();
    return [current, current - 1, current - 2, current - 3];
}

function getMonthRange(year, month) {
    const start = `${year}-${String(month).padStart(2, "0")}-01`;
    const lastDay = new Date(year, month, 0).getDate();
    const end = `${year}-${String(month).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
    return { start, end };
}

export default function Amc_report() {
    const { http, user } = AuthUser();
    const [tasks, setTasks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [company, setCompany] = useState([]);
    const [selectCompany, setselectedCompany] = useState("");
    const [startDate, setstartDate] = useState("");
    const [selectResolve, setselectedResolve] = useState("");
    const [endDate, setendDate] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("");
    const [selectedYear, setSelectedYear] = useState("");

    useEffect(() => {
        fetchTaskDetails(selectCompany, startDate, endDate, selectResolve);
    }, [selectCompany, startDate, endDate, selectResolve]);

    const fetchTaskDetails = (
        companyset = "",
        start = "",
        end = "",
        resolve = "ALL"
    ) => {
        setIsLoading(true);
        let endpoint = `/get_amc_report?login_user=${user.id}&company=${companyset}&startdate=${start}&enddate=${end}&resolve=${resolve}`;

        http.get(endpoint)
            .then((res) => {
                setIsLoading(false);
                if (Array.isArray(res.data.users)) {
                    setTasks(res.data.users);
                } else {
                    console.error("API response is not an array");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error fetching tasks:", error);
            });

        http.get(`/unique_company?login_user=${user.id}`).then((res) => {
            setCompany(res.data.data);
        });
    };

    const handleChange = (event) => {
        setselectedCompany(event.target.value);
    };

    const handleChangeResolve = (event) => {
        setselectedResolve(event.target.value);
    };

    const handleChangeStartDate = (event) => {
        setstartDate(event.target.value);
        setSelectedMonth("");
        setSelectedYear("");
    };

    const handleChangeEndDate = (event) => {
        setendDate(event.target.value);
        setSelectedMonth("");
        setSelectedYear("");
    };

    const handleMonthChange = (event) => {
        const month = event.target.value ? parseInt(event.target.value, 10) : "";
        setSelectedMonth(event.target.value);
        if (month && selectedYear) {
            const { start, end } = getMonthRange(parseInt(selectedYear, 10), month);
            setstartDate(start);
            setendDate(end);
        } else if (!month) {
            setstartDate("");
            setendDate("");
        }
    };

    const handleYearChange = (event) => {
        const year = event.target.value;
        setSelectedYear(year);
        if (year && selectedMonth) {
            const { start, end } = getMonthRange(parseInt(year, 10), parseInt(selectedMonth, 10));
            setstartDate(start);
            setendDate(end);
        } else if (!year) {
            setstartDate("");
            setendDate("");
        }
    };

    const years = getYears();

    return (
        <>
            <div className="container mt-1">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h1 className="mb-0">AMC Report</h1>
                  <button
                    className="btn btn-sm btn-outline-success"
                    disabled={tasks.length === 0}
                    onClick={() => downloadCSV(
                      [["No", "Company", "Total Online", "Total Offline", "Total Hour", "Total Rate", "Total Bill Value"],
                       ...tasks.map((r, i) => [i + 1, r.company, r.total_online, r.total_offline, r.total_ext1, r.total_ext1 * 200, r.total_bill_value])],
                      `amc_report_${moment().format("YYYYMMDD_HHmm")}.csv`
                    )}
                  >⬇ CSV</button>
                </div>
                <div className="row align-items-end">
                    <div className="col-md-2 form-group mt-2 mb-2">
                        <label className="form-label">Company</label>
                        <select onChange={handleChange} className="form-control mb-1" value={selectCompany}>
                            <option value="">All Company</option>
                            {company.map((depart) => (
                                <option key={depart.id} value={depart.company}>
                                    {depart.company}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-2 form-group mt-2 mb-2">
                        <label className="form-label">Month</label>
                        <select
                            className="form-control"
                            value={selectedMonth}
                            onChange={handleMonthChange}
                        >
                            <option value="">Select month</option>
                            {MONTHS.map((m) => (
                                <option key={m.value} value={m.value}>{m.label}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-2 form-group mt-2 mb-2">
                        <label className="form-label">Year</label>
                        <select
                            className="form-control"
                            value={selectedYear}
                            onChange={handleYearChange}
                        >
                            <option value="">Select year</option>
                            {years.map((y) => (
                                <option key={y} value={y}>{y}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-2 form-group mt-2 mb-2">
                        <label className="form-label">From Date</label>
                        <input
                            name="start_date"
                            onChange={handleChangeStartDate}
                            className="form-control"
                            type="date"
                            value={startDate}
                        />
                    </div>
                    <div className="col-md-2 form-group mt-2 mb-2">
                        <label className="form-label">To Date</label>
                        <input
                            name="end_date"
                            onChange={handleChangeEndDate}
                            className="form-control"
                            type="date"
                            value={endDate}
                        />
                    </div>
                </div>

                <div className="table-responsive">
                    {isLoading ? (
                        <TaskSkeleton />
                    ) : (
                        <table className="table table-striped center_tbl">
                            <thead className="table-primary">
                                <tr>
                                    <th>No</th>
                                    <th>Company</th>
                                    <th>Total Online</th>
                                    <th>Total Offline</th>
                                    <th>Total Hour</th>
                                    <th>Total Rate</th>
                                    <th>Total Bill Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tasks.map((task, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{task.company}</td>
                                        <td>{task.total_online}</td>
                                        <td>{task.total_offline}</td>
                                        <td>{task.total_ext1}</td>
                                        <td>{task.total_ext1 * 200}</td>
                                        <td>{task.total_bill_value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </>
    );
}
